import { Fragment } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Preloader from "../../components/Preloader/Preloader";
import { Outlet } from "react-router-dom";
import { useProfileStore } from "../../store/useUserStore";

const DefaultLayout = () => {
    const { loading } = useProfileStore()
    
    return (
        <div className="flex flex-col h-[100dvh] overflow-hidden">
            <Header />
            <main className="flex-1 overflow-y-auto pb-[80px]">
                <Outlet/>
            </main>
            {loading && <Preloader/>}
            <Footer/>
        </div>
    );
};

export default DefaultLayout;
